import { request } from 'sonata-react-components';
import { getCountryName } from 'sonata-static-storage/lib/helpers/countries.helpers';

export async function fetchCountryBounds(countryCca3: string): Promise<[number, number, number, number] | null> {
  const query = getCountryName(countryCca3) || countryCca3;
  if (!query) {
    return null;
  }
  const url = `${taptap.config.mapbox.url}${taptap.config.mapbox.geocoderURL}${encodeURIComponent(query)}.json`;
  const response: { features?: Array<{ bbox?: number[] }> } = await request.makeRequest(url, {
    method: 'GET',
    params: { access_token: taptap.config.mapbox.accessToken, limit: 1, types: 'country' }
  });
  const box = response.features?.[0]?.bbox;
  return box && box.length === 4 ? [box[0], box[1], box[2], box[3]] : null;
}
